<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h1>{{ site.name }}</h1>
            <h4>
              {{ site.domain }}
            </h4>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h3>{{ $t("gpool.added_games") }}</h3>
          </div>
          <div class="card-body">
            <SiteGamesGames />
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h3>{{ $t("gpool.not_added_games") }}</h3>
          </div>
          <div class="card-body">
            <Games />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SiteGamesGames from "../components/siteGames/SiteGamesGames";
import Games from "../components/siteGames/Games";
export default {
  name: "SiteGames",
  components: {
    SiteGamesGames,
    Games
  },
  beforeDestroy() {
    this.resetSite();
  },
  computed: {
    ...mapGetters("site", ["site"])
  },
  mounted() {
    this.getSite(this.$route.params.id);
  },
  methods: {
    ...mapActions("site", ["getSite", "resetSite"])
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/SiteGames.vue